import React from "react";

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  showDots?: boolean;
  className?: string;
}

const DOT_COLORS = [
  "#2D5A4A", // Forest green
  "#C4785C", // Terracotta
  "#4A6FA5", // Blue
  "#6B5B8C", // Purple
  "#B8956B", // Amber
  "#7A8C6B", // Sage
];

const SIZES = {
  sm: { text: "text-xl", dot: "w-2 h-2", gap: "gap-2" },
  md: { text: "text-2xl", dot: "w-2.5 h-2.5", gap: "gap-2.5" },
  lg: { text: "text-4xl", dot: "w-3 h-3", gap: "gap-3" },
  xl: { text: "text-5xl", dot: "w-3.5 h-3.5", gap: "gap-3.5" },
};

export function Logo({ size = "md", showDots = true, className = "" }: LogoProps) {
  const sizeConfig = SIZES[size];

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <div className={`${sizeConfig.text} tracking-tight font-display`}>
        <span className="font-semibold text-foreground">cradle</span>
        <span className="font-light italic text-foreground">OS</span>
      </div>
      {showDots && (
        <div className={`flex items-center ${sizeConfig.gap} mt-1`}>
          {DOT_COLORS.map((color, index) => (
            <div
              key={index}
              className={`${sizeConfig.dot} rounded-full`}
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
